import { styled } from '@mui/material'

export const ImageContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  & img {
    width: ${({ theme }) => theme.spacing(22.75)};
  }
  gap: ${({ theme }) => theme.spacing(1.5)};
`

export const ActionButtonWrapper = styled('div')`
  display: flex;
  justify-content: center;
`
